import React, { memo } from 'react';
import PropTypes from 'prop-types';
import PlusIcon from 'svg/PlusIcon';
import PauseIcon from 'svg/PauseIcon';
import CloseIcon from 'svg/CloseIcon';
import PlayIcon from 'svg/PlayIcon';
import ArrowUpIcon from 'svg/arrowUp';
import ArrowDownIcon from 'svg/arrowDown';
import NotificationIcon from 'svg/NotificationIcon';
import MoreIcon from 'svg/MoreIcon';
import CopyIcon from 'svg/CopyIcon';
import ResetIcon from 'svg/ResetIcon';
import BackIcon from 'svg/BackIcon';

import { colorize, opacifyOnHover } from 'theming/theme';
import styled, { css } from 'styled-components';

const Button = ({
  type,
  onClick = () => {},
  onMouseDown = () => {},
  onMouseUp = () => {},
  onMouseLeave = () => {},
  onTouchStart = () => {},
  onTouchEnd = () => {},
  className = '',
  title = '',
  onMouseOver = () => {},
  onFocus = () => {},
}) => (
  <ButtonTag
    type="button"
    className={className}
    $buttonType={type}
    onClick={onClick}
    onMouseDown={onMouseDown}
    onMouseUp={onMouseUp}
    onMouseLeave={onMouseLeave}
    onTouchStart={onTouchStart}
    onTouchEnd={onTouchEnd}
    onMouseOver={onMouseOver}
    onFocus={onFocus}
    title={title}
  >
    <IconWrapper>
      {type === 'plus' && (
        <PlusIcon
          height={20}
          width={20}
        />
      )}
      {type === 'pause' && (
      <PauseIcon
        height={15}
        width={15}
      />
      )}
      {type === 'close' && (
      <CloseIcon
        height={20}
        width={20}
      />
      )}
      {type === 'play' && (
      <PlayIcon
        height={18}
        width={18}
      />
      )}
      {type === 'up' && (
      <ArrowUpIcon
        width={16}
        height={8}
      />
      )}
      {type === 'down' && (
      <ArrowDownIcon
        width={16}
        height={8}
      />
      )}
      {type === 'notification' && (
      <NotificationIcon />
      )}
      { type === 'more' && (
      <MoreIcon
        height={24}
      />
      )}
      { type === 'copy' && (
      <CopyIcon
        height={24}
        width={24}
      />
      )}
      { type === 'reset' && (
      <ResetIcon />
      )}
      { type === 'back' && (
      <BackIcon
        height={24}
        width={24}
      />
      )}
    </IconWrapper>
  </ButtonTag>
);
const IconWrapper = styled.div`
  display: flex;
`;

const ButtonTag = memo(styled.button`
  width: 42px;
  height: 42px;
  background: ${(props) => props.theme.main.buttonDefault};
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  padding: 0;
  transition: .3s;
  &:focus{
  outline: 0;
  }
  ${(props) => {
    switch (props.$buttonType) {
      case 'plus':
        return colorize(props.theme.main.buttonPlus);
      case 'pause':
        return colorize(props.theme.main.buttonPause);
      case 'play':
        return css`
        ${colorize(props.theme.main.buttonPlay)}
        ${IconWrapper}{
          margin-left: 5px;
        }
        `;
      case 'close':
        return colorize(props.theme.main.buttonClose);
      case 'notification':
        return colorize(props.theme.main.buttonPlus);
      case 'more':
        return css`
         ${opacifyOnHover(0.5)}
`;
      case 'copy':
        return css`
          ${opacifyOnHover(0.5)}
`;
      case 'back':
        return css`
          ${opacifyOnHover(0.5)}
`;
      case 'reset':
        return css`
         ${opacifyOnHover(0.5)}
         ${IconWrapper}{
          margin-right: 5px;
        }
`;
      case 'up':
        return css`
        border-radius: 0;
        background: none;
        height: 14px;
        width: unset;
        align-items: flex-end;
        justify-content: flex-end;
        align-content: flex-end;
        flex-direction: column;
        margin-bottom: 2px;
        `;
      case 'down':
        return css`
        border-radius: 0;
        background: none;
        height: 14px;
        width: unset;
        align-items: flex-start;
        justify-content: flex-start;
        align-content: flex-start;
        flex-direction: column;
        margin-bottom: unset;
        margin-top: 2px;
        `;
      default:
        return colorize(props.theme.main.buttonPlus);
    }
  }
}
`);

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['plus', 'pause', 'play', 'close', 'up', 'down', 'notification', 'more', 'copy', 'back', 'reset']).isRequired,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onTouchStart: PropTypes.func,
  onTouchEnd: PropTypes.func,
  onMouseOver: PropTypes.func,
  onFocus: PropTypes.func,
  title: PropTypes.string,
};

export default memo(Button);
